module.exports = __webpack_public_path__ + "static/mbakwem-539d98314ea229059c74b4c02c37ad67.png";